import { useMemo } from "react";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailActionConfirmModal } from "./HeldEmailActionConfirmModal";

interface ConfirmReleaseHeldEmailsModalProps {
  emails: HeldEmailListItem[];
  opened: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function releaseMessage(emails: HeldEmailListItem[]): string {
  const blocked = emails.filter((email) => email.state === "blocked");
  if (blocked.length === 0) return normalReleaseMessage(emails.length);
  const recipients = blocked
    .map((email) => `${email.emailTypeLabel} to ${email.recipient}`)
    .join("; ");
  return `This overrides Off for these messages only: ${recipients}.`;
}

function normalReleaseMessage(count: number): string {
  return count === 1
    ? "This email will be sent to its originally intended recipient."
    : `${count} emails will be sent to their originally intended recipients.`;
}

function useReleaseConfirmation(emails: HeldEmailListItem[]) {
  return useMemo(() => {
    const blocked = emails.some((email) => email.state === "blocked");
    return {
      actionLabel: blocked
        ? `Send blocked email${emails.length === 1 ? "" : "s"}`
        : "Release",
      color: blocked ? "red" : undefined,
      message: releaseMessage(emails),
      title: blocked ? "Send blocked email?" : "Release queued email?",
    };
  }, [emails]);
}

export function ConfirmReleaseHeldEmailsModal(
  props: ConfirmReleaseHeldEmailsModalProps
) {
  const { emails, ...dialog } = props;
  const confirmation = useReleaseConfirmation(emails);
  return (
    <HeldEmailActionConfirmModal
      model={{ ...dialog, ...confirmation, cancelLabel: "Cancel" }}
    />
  );
}
